var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M8.586 7L3.293 1.707A1 1 0 114.707.293l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L8.586 7z","fill":"currentColor","fillRule":"nonzero"})));
}

ChevronRight.defaultProps = {"width":"10","height":"10","viewBox":"0 0 14 14"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
